import { Fragment, useEffect } from 'react';
import { Breakpoints, TextLink, TextLinkStyle, useBreakpoint, useTranslation } from '@nextgen-web-framework/all';
import { TextContentResultsProps } from './types/propTypes';
import TextCardLoader from './TextCardLoader/TextCardLoader';
import TextCard from './TextCard/TextCard';
import styles from './TextContentResults.module.scss';

const MAX_CARD_ITEMS = 3;

const TextContentResults = ({
  sectionTitle,
  resultItems,
  loading,
  searchResultPageVariant,
  className,
  loadingItems = 3,
  onViewAllClick,
  setLastTile,
}: TextContentResultsProps) => {
  const t = useTranslation();
  const viewport = useBreakpoint() as Breakpoints;
  const loaderItems = [...Array(loadingItems)].map((_, index) => index);
  const hasNotContents = !loading && resultItems.length === 0;
  useEffect(() => {
    const lastTile = document.querySelector<HTMLLIElement>('.text-card-content-search:last-child');
    if (lastTile && setLastTile) {
      setLastTile(lastTile);
    }
  }, [resultItems]);

  const divider = (
    <svg width="100%" height="1" viewBox="0 0 100 1" fill="none" preserveAspectRatio="none">
      <path d="M0 0.5H1344" stroke="#E4E4E4"></path>
    </svg>
  );

  return (
    <div className={`${styles['text-content-results']} ${className}`}>
      {hasNotContents ? null : (
        <div className={styles['section-header']}>
          <div
            className={`${styles['section-title']} ${
              searchResultPageVariant && ![Breakpoints.XS, Breakpoints.SM].includes(viewport) && styles['font-h4']
            }`}
          >
            {sectionTitle}
          </div>
          {onViewAllClick && (
            <TextLink
              text={t('search.textContentResults.viewAll')}
              textLinkStyle={TextLinkStyle.UNDERLINE}
              data-testid="view-all-test-id"
              onClick={(e) => {
                e.preventDefault();
                onViewAllClick();
              }}
            />
          )}
        </div>
      )}
      <div className={styles['text-card-items']}>
        {resultItems.map((item, i) => (
          <Fragment key={item.title}>
            <TextCard {...item} />
            {(!searchResultPageVariant || i !== resultItems.length - 1) && divider}
          </Fragment>
        ))}
        {loading &&
          loaderItems.map((i) => (
            <Fragment key={i}>
              <TextCardLoader />
              {(!searchResultPageVariant || i !== MAX_CARD_ITEMS - 1) && divider}
            </Fragment>
          ))}
      </div>
    </div>
  );
};

export default TextContentResults;
export type { TextContentResultsProps };
